<div class="container mt-30">
  <fgbcl-marketplace-list-v2 [isList]="true" [marketplaceItemView]="true" [marketplaceItemTypes]="[0, 1, 2]" [defaultSort]="2" />
</div>
